import withAPIAction from 'helpers/withAPIAction'
import {
  ListReq,
  DetailReq,
  UpdateReq,
  BestTrackingReq,
  LogsReq,
  NewOrderReq,
  BillReq,
  TerminalStatusReq,
  UpdateOrderAddressReq,
  UpdatePaymentTypeReq,
} from './types'
import {
  getListAction,
  updateAction,
  getDetailAction,
  createBestTrackingAction,
  getOrderLogsAction,
  countNewOderAction,
  getPosBillAction,
  updateTerminallStatusAutoAction,
  updateOrderAddressAction,
  updatePaymentTypAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'
import { getRequestString } from 'helpers/format'

export const orderListAPI = (data: ListReq, token: string, xmid: string) => {
  return withAPIAction<ListReq>({
    method: 'POST',
    baseUrl: appConfig.apiOrderEndpoint,
    path: APIPath.getOrderList,
    data,
    token,
    xmid,
  })(getListAction)
}

export const updateOrderStatusAPI = (data: UpdateReq, token: string, xmid: string) => {
  return withAPIAction<UpdateReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.updateOrderStatus,
    data,
    token,
    xmid,
  })(updateAction)
}

export const updateTerminalOrderStatusAPI = (data: TerminalStatusReq, token: string, xmid: string) => {
  return withAPIAction<TerminalStatusReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.updateTerminalStatusAuto,
    data,
    token,
    xmid,
  })(updateTerminallStatusAutoAction)
}

export const getOrderDetailAPI = (data: DetailReq, token: string, xmid: string) => {
  return withAPIAction<DetailReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.getOrderByID,
    data,
    token,
    xmid,
  })(getDetailAction)
}

export const createBestTrackingAPI = (data: BestTrackingReq, token: string) => {
  return withAPIAction<BestTrackingReq>({
    method: 'GET',
    baseUrl: appConfig.apiExpressEndpoint,
    path: `${APIPath.createBestTracking}?${getRequestString(data)}`,
    data,
    //token,
    // hideAuthMid: true,
    hideOath: true,
  })(createBestTrackingAction)
}

export const getOrderLogsAPI = (data: LogsReq, token: string) => {
  return withAPIAction<LogsReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.getOrderLogs,
    data,
    token,
    // xmid,
  })(getOrderLogsAction)
}

export const countNewOrderAPI = (data: NewOrderReq, token: string, xmid: string) => {
  return withAPIAction<NewOrderReq>({
    method: 'GET',
    baseUrl: appConfig.apiOrderEndpoint,
    path: APIPath.countNewOrder,
    data,
    token,
    xmid,
  })(countNewOderAction)
}

export const getPosBillAPI = (data: BillReq, token: string) => {
  const endPoint = APIPath.getPOSBill.replace(':id', data.orderID.toString())
  return withAPIAction<BillReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
  })(getPosBillAction)
}

export const updateOrderAddressAPI = (data: UpdateOrderAddressReq, token: string, xmid: any) => {
  return withAPIAction<UpdateOrderAddressReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.updateTerminalAddress,
    data,
    token,
    xmid,
  })(updateOrderAddressAction)
}

export const updatePaymentTypeAPI = (data: UpdatePaymentTypeReq, token: string, xmid: any) => {
  return withAPIAction<UpdatePaymentTypeReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.updatePaymentType,
    data,
    token,
    xmid,
  })(updatePaymentTypAction)
}
